"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeExpressionMaps = void 0;
const arrayProps = [
    'aliases',
    'selects',
    'selectDistinctOn',
    'joinAttributes',
    'wheres',
    'havings',
    'orderBys',
    'groupBys',
    'insertColumns',
    'whereEntities',
    'pluginConditions',
    'pluginConfigs'
];
const overrideProps = ['selects', 'selectDistinctOn'];
const matches = {
    selects: 'selection',
    orderBys: 'propertyPath',
    joinAttributes: 'entityOrProperty'
};
function mergeExpressionMaps(a, b, override = false) {
    const expressionMap = Object.assign(Object.assign({}, a), b);
    const properties = override
        ? arrayProps.filter(property => {
            return !overrideProps.includes(property);
        })
        : arrayProps;
    // merge array properties
    for (const property of properties) {
        const aItems = a[property] || [];
        const bItems = b[property] || [];
        // avoid merging duplicate property values
        const matchProperty = matches[property];
        if (!matchProperty) {
            expressionMap[property] = aItems.concat(bItems);
            continue;
        }
        // for orderBys, prioritize second expressionMap
        const prioritizeBItems = property === 'orderBys';
        const items1 = prioritizeBItems ? bItems : aItems;
        const items2 = prioritizeBItems ? aItems : bItems;
        const copy = Array.from(items1);
        for (const bItem of items2) {
            if (!copy.some(aItem => aItem[matchProperty] === bItem[matchProperty])) {
                copy.push(bItem);
            }
        }
        expressionMap[property] = copy;
    }
    // prioritize second expressionMap when overriding
    if (override) {
        for (const property of overrideProps) {
            const value = b[property] || a[property] || [];
            expressionMap[property] = value;
        }
    }
    return expressionMap;
}
exports.mergeExpressionMaps = mergeExpressionMaps;
//# sourceMappingURL=mergeExpressionMaps.js.map